import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 10px;
  padding: 24px;
`

export const CloseIcon = styled.div`
  cursor: pointer;
  background: none;
  color: ${colors.strongGray};
`

export const TopTitle = styled.div`
  font-size: 16px;
  color: ${colors.strongGray};
  margin-bottom: 5px;
`
